import { render, staticRenderFns } from "./form.vue?vue&type=template&id=5a85e60a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=5a85e60a&prod&lang=scss"
import style1 from "./form.vue?vue&type=style&index=1&id=5a85e60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85e60a",
  null
  
)

export default component.exports